import { render, staticRenderFns } from "./NewAnnalModal.vue?vue&type=template&id=2dafab62&scoped=true"
import script from "./NewAnnalModal.vue?vue&type=script&lang=js"
export * from "./NewAnnalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dafab62",
  null
  
)

export default component.exports